@if (questions?.length > 0) {
  <div class="form-group form-group--sm">
    <app-question-textbox
      [question]="getQuestion(2504)"
      (questionAnswer)="saveValue($event)"
      [showLabel]="true">
    </app-question-textbox>
  </div>
  <div class="form-group form-group--sm">
    <app-question-textbox
      [question]="getQuestion(2505)"
      (questionAnswer)="saveValue($event)"
      [showLabel]="true">
    </app-question-textbox>
  </div>
  <div class="form-group form-group--sm">
    <app-question-date-of-birth [question]="getQuestion(2506)" [showLabel]="true"
      (questionAnswer)="saveValue($event, 2506)">
    </app-question-date-of-birth>
  </div>
  <div class="form-group form-group--sm">
    <app-question-dropdown [question]="getQuestion(2507)" [options]="relationships" [showLabel]="true"  [showQuestionCopyLabel]="true"
      [selectedValue]="getQuestion(2507)?.answer" (questionAnswer)="setCoverOptions($event)">
    </app-question-dropdown>
  </div>
  <div class="form-group form-group--sm">
    <app-question-dropdown-currency [question]="getQuestion(2508)" [options]="filteredOptions" [showLabel]="true" [showQuestionCopyLabel]="true"
      [selectedValue]="selectedOption" (questionAnswer)="saveValue($event)">
    </app-question-dropdown-currency>
  </div>
}